<template>
  <div class="report">
    <div class="flex xs12 " align="right">
      <va-card class="">
        <va-card-title>
          <h1 class="flex md10" style="text-align: left;">Power BI Reports</h1>

          <va-button class="flex md2" @click="clickDownloadAsPDF()">Email as PDF</va-button>
        </va-card-title>
        <va-card-content>
          <small class="flex md12" style="text-align: left;">Report ID: {{ this.codename }}</small>
        </va-card-content>
      </va-card>
    </div>
    <div class="row">
      <div id="container" class="flex md12 xs12"> </div>
    </div>
  </div>

</template>

<script>
import * as pbi from 'powerbi-client';
import { mapState, mapActions } from "vuex";
export default {
  name: "report",
  props: ['codename'],
  data() {
    return {
      config: {
        type: 'report',
        tokenType: pbi.models.TokenType.Embed,
        accessToken: '',
        embedUrl: '',
        permissions: pbi.models.Permissions.All,
        settings: {
          filterPaneEnabled: false,
          navContentPaneEnabled: true,
        },
      },
      selected: null,
      powerbi: null,
      reportContainer: null,
      selectEntityId: 0,
    }
  },
  computed: {
    ...mapState({
      availableReports: state => state.report.availableReports ? state.report.availableReports : [],
      reportInfo: state => state.report.reportInfo,
    }),
  },
  watch: {
    reportInfo(newValue, oldValue) {
      if (newValue) {
        this.config.accessToken = newValue.accessToken;
        this.config.embedUrl = newValue.embedUrl;
        const report = this.powerbi.embedNew(this.reportContainer, this.config);
        if (report) {
          report.on("loaded", function () {
          });
          report.off("loaded");
          report.off("rendered");
          report.on("error", function () {
            report.off("error");
          });
        }
      }
    },
    codename(newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        if (this.codename) {
          this.getReportEmbedInfo({ codename: this.codename })
        }
      }
    },
  },
  methods: {
    ...mapActions({
      getReportEmbedInfo: "report/getReportEmbedInfo",
      exportReportAndEmail: "report/exportReportAndEmail",
    }),
    valueSelected(value) {
      this.selected = value;
      const { workspace_id, report_id } = value;
      //this.getReportEmbedInfo({workspaceId:workspace_id, reportId:report_id})
    },
    clickDownloadAsPDF() {
      const r = window.confirm('Do you want the report be exported as a pdf document and send to your email box?');
      if (!r) {
        window.confirm('Failed to export the report as pdf.')
      }
      if (r == true) {
        this.exportReportAndEmail({ codename: this.codename })
      }

    },
  },
  mounted() {
    this.powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);
    this.reportContainer = document.getElementById('container');
    if (this.codename) {
      this.getReportEmbedInfo({ codename: this.codename })
    }
  },
}
</script>
<style lang="scss" scoped>
.report {
  width: 100%;
  height: 100%;
}

#container {
  width: 100%;
  min-height: 100%;
  width: 100%;
  height: 800px;
  border: 400px;
}
</style>

